/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext } from "react";
import { radiusEndpointBase } from "../../../constants/Endpoint";
import { Button } from "reactstrap";
import { LoginContext } from "../../../Context";

const googleAuthUrl = "https://accounts.google.com/o/oauth2/v2/auth";
const googleClientId = "1075018044671-ecno592kppe5breutd4ebdpkil245o51.apps.googleusercontent.com";
const googleRedirect = `${radiusEndpointBase}google/guest/callback`

const GoogleLoginButton = (props) => {
  const loginContext = useContext(LoginContext);
  const getURLWithQueryParams = (base, params) => {
    const query = Object
      .entries(params)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&')
      
    return `${base}?${query}`
  }

  const login = () => {
    const currentUrl = window.location.href;
    const lastSlashIndex = currentUrl.lastIndexOf("/");
    const urlStrippedRoute = currentUrl.substring(0, lastSlashIndex);
    const urlVerifyRoute = urlStrippedRoute + "/verify";
    const redirect = loginContext.config?.dashboardDomain ? `https://${loginContext.config.dashboardDomain}:8080/google/guest/callback` : googleRedirect;
    const customClientId = loginContext.config?.googleConfig?.clientId;
    
    const authUrl = getURLWithQueryParams(googleAuthUrl, {
      client_id:  customClientId ?? googleClientId,
      redirect_uri: redirect,
      response_type: "code",
      scope: "openid profile email",
      access_type: "offline",
      include_granted_scopes: "true",
      enable_serial_consent: "true",
      state: JSON.stringify({
        redirect_url: urlVerifyRoute
      }),
    });

    // Send the initial request to start the workflow
    // cloud should respond with an html page containing router info after user signs in
    const url = new URL(authUrl, window.location.href);

    // navigate to url
    window.location.href = url.toString();
  }
    
  return <Button {...props} onClick={login} />
};

export default GoogleLoginButton;
